export default __webpack_public_path__ + "static/pattern_03-688f60031dcf2d826f0e5c81bda8a4fa.png";